import { Component, OnInit, ViewEncapsulation, AfterViewInit } from "@angular/core";


@Component({
    selector: 'app-pep-info',
    templateUrl: "./pep-info.component.html",
    styleUrls: ["./pep-info.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class PEPInfoComponent implements OnInit, AfterViewInit {

    constructor() {

    }


    ngOnInit(): void {

    }

    ngAfterViewInit() {

    }

    navigateToBlockId(blockId) {
        const elmId = `pep_${blockId}_info`;
        const elm: HTMLElement = document.getElementById(elmId) as HTMLElement;
        if (elm) {
            elm.scrollIntoView({ behavior: "smooth" });
        }
    }
}
